/**
 * @generated SignedSource<<2d90f72daa680705b0346d9aa7af3300>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type CreateWidgetIntegrationFlourishPraiseInput = {
  positionX: number;
  positionY: number;
  size: WidgetOverviewSize;
};
export type WAIntegrationFlourishPraiseMutation$variables = {
  input: CreateWidgetIntegrationFlourishPraiseInput;
  storecastId: string;
};
export type WAIntegrationFlourishPraiseMutation$data = {
  readonly dashboard: {
    readonly createWidgetIntegrationFlourishPraise: {
      readonly id: string;
    };
  };
};
export type WAIntegrationFlourishPraiseMutation = {
  response: WAIntegrationFlourishPraiseMutation$data;
  variables: WAIntegrationFlourishPraiseMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "dashboardId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "DashboardMutation",
    "kind": "LinkedField",
    "name": "dashboard",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "widget",
            "variableName": "input"
          }
        ],
        "concreteType": "WidgetIntegrationFlourishPraise",
        "kind": "LinkedField",
        "name": "createWidgetIntegrationFlourishPraise",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WAIntegrationFlourishPraiseMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WAIntegrationFlourishPraiseMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "aab6de6ab2620246a4183a9ff1913c84",
    "id": null,
    "metadata": {},
    "name": "WAIntegrationFlourishPraiseMutation",
    "operationKind": "mutation",
    "text": "mutation WAIntegrationFlourishPraiseMutation(\n  $storecastId: ID!\n  $input: CreateWidgetIntegrationFlourishPraiseInput!\n) {\n  dashboard(dashboardId: $storecastId) {\n    createWidgetIntegrationFlourishPraise(widget: $input) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5e940525da71aea107d6aacc129e15f";

export default node;
